/** List of available client type classifications. */
export const clientTypes = [
  'retail',
  'ib',
  'affiliate',
  'corporate',
  'coldLead',
  'ibCorporate',
  'affiliateCorporate',
  'jointAccount',
  'testClient',
  'merchant',
  'professional',
  'eligibleCounterParty',
  'strategicPartner',
  'fundAgent',
  'fundInvestor',
  'hybrid',
] as const
